<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ "repository.clients.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="creation-form" *ngIf="!isAdminClient">
      <button
        *ngIf="!isCreationMode"
        (click)="onEdit()"
        [matTooltip]="'repository.clients.list.add' | translate"
        mat-mini-fab
        class="action-button"
        color="primary"
      >
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-client-edit
        *ngIf="isCreationMode && !editedId"
        (editFinished)="onEditFinished()"
      ></app-client-edit>
    </section>

    <mat-form-field class="filterField" *ngIf="!isAdminClient">
      <mat-label>Filtrer</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Votre filtre"
        #input
      />
    </mat-form-field>

    <section class="datatable-wrapper">
      <div class="datatable-container">
        <app-displayed-columns-menu
          [columnsParams]="columnsParams"
          (onMooveColumnsOrderEvent)="onMooveColumnsOrder($event)"
          (onSelectColumnVisibilityEvent)="onSelectColumnVisibility($event)"
        ></app-displayed-columns-menu>

        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          multiTemplateDataRows
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              <div style="display: flex; align-items: center">
                <mat-icon
                  color="primary"
                  style="font-size: 18px"
                  [matTooltip]="'Sous-traitant'"
                  *ngIf="!isAdminClient && client.isSubcontractor"
                >
                  business
                </mat-icon>
                {{ client.name }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.email" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.email }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="features">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.clients.list.features' | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              <ul *ngIf="client?.features?.length > 0 && client?.features?.length < 4">
                <li *ngFor="let feature of client.features">{{feature.name}}</li>
              </ul>
              <ng-container *ngIf="client?.features?.length === 4">
                <div class="allFeatures">
                  <u>Tous</u>
                </div>

                <div class="containerFeatures">
                  <ul *ngIf="client?.features?.length > 0">
                    <li *ngFor="let feature of client.features">{{feature.name}}</li>
                  </ul>
                </div>
              </ng-container>
            </td>
          </ng-container> -->

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.phone" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.phone }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fax">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.fax" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.fax }}
            </td>
          </ng-container>

          <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.contact" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.contact }}
            </td>
          </ng-container>

          <ng-container matColumnDef="webSite">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.webSite" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.webSite }}
            </td>
          </ng-container>

          <ng-container matColumnDef="street">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.street" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.street }}
            </td>
          </ng-container>

          <ng-container matColumnDef="streetNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.streetNumber" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.streetNumber }}
            </td>
          </ng-container>

          <ng-container matColumnDef="locality">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.locality" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.locality }}
            </td>
          </ng-container>

          <ng-container matColumnDef="postalCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.postalCode" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.postalCode }}
            </td>
          </ng-container>

          <ng-container matColumnDef="siret">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.siret" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.siret }}
            </td>
          </ng-container>

          <ng-container matColumnDef="ape">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.ape" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.ape }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tva">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ "repository.clients.list.tva" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              {{ client.tva }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              {{ "repository.clients.list.actions" | translate }}
            </th>
            <td mat-cell *matCellDef="let client">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Menu boutons"
                color="primary"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <ng-container *ngIf="client.id !== editedId">
                  <button
                    mat-menu-item
                    class="action-button"
                    [disabled]="isLoading"
                    (click)="onEdit(client.id)"
                  >
                    <mat-icon aria-label="Edit" color="primary">edit</mat-icon>
                    <span>{{
                      "repository.clients.list.edit" | translate
                    }}</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="!isAdminClient">
                  <button
                    mat-menu-item
                    class="action-button"
                    [disabled]="isLoading"
                    (click)="delete(client.id)"
                  >
                    <mat-icon aria-label="Delete" color="primary"
                      >delete</mat-icon
                    >
                    <span>{{
                      "repository.clients.list.delete" | translate
                    }}</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="client.hasLogo">
                  <button
                    mat-menu-item
                    class="action-button"
                    [disabled]="isLoading"
                    (click)="downloadLogo(client.id)"
                  >
                    <mat-icon aria-label="Image" color="primary"
                      >file_download</mat-icon
                    >
                    <span>{{
                      "repository.clients.list.downloadLogo" | translate
                    }}</span>
                  </button>
                </ng-container>

                <ng-container>
                  <button
                    mat-menu-item
                    class="action-button"
                    [disabled]="isLoading"
                    (click)="openDialog(client)"
                  >
                    <mat-icon aria-label="Image" color="primary"
                      >image</mat-icon
                    >
                    <span>{{
                      "repository.clients.list.logo" | translate
                    }}</span>
                  </button>
                </ng-container>

                <ng-container *ngIf="isAdmin">
                  <button
                    mat-menu-item
                    class="action-button"
                    [disabled]="isLoading"
                    (click)="openKooveaDialog(client)"
                  >
                    <mat-icon aria-label="Image" color="primary"
                      >device_thermostat</mat-icon
                    >
                    <span>{{
                      "repository.clients.list.kooveaManagement" | translate
                    }}</span>
                  </button>
                </ng-container>
              </mat-menu>
            </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let client"
              [attr.colspan]="displayedColumns.length"
            >
              <div
                *ngIf="client.id === editedId"
                class="row-edit"
                [@detailExpand]="
                  client.id === editedId ? 'expanded' : 'collapsed'
                "
              >
                <app-client-edit
                  [client]="client"
                  (editFinished)="onEditFinished()"
                ></app-client-edit>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="row"
            [ngClass]="{ 'expanded-row': row.id === editedId }"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="detail-row"
          ></tr>
        </table>
        <mat-paginator
          *ngIf="!isAdminClient"
          class="paginator"
          [pageSizeOptions]="[20, 25, 50, 100]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </section>
    <mat-progress-bar
      *ngIf="isLoading"
      class="progress-bar"
      mode="indeterminate"
      color="primary"
    ></mat-progress-bar>
  </mat-card-content>
</mat-card>
